import React from 'react';
import { useCalculator } from '../context/CalculatorContext';

const DataInputForm: React.FC = () => {
  const { formState, showStdDev, handleInputChange } = useCalculator();

  return (
    <div className="p-4 bg-gray-50 dark:bg-gray-700/30 rounded-lg space-y-6">
      <h3 className="font-medium">Input Your Data</h3>
    
      {/* Baseline Value */}
      <div>
        <label htmlFor="baselineValue" className="block text-sm font-medium mb-2">
          {formState.testType === 'conversion' ? 'Baseline Conversion Rate (%)' : 'Baseline Metric Value'}
        </label>
        <input
          type="number"
          id="baselineValue"
          name="baselineValue"
          min="0.01"
          step={formState.testType === 'conversion' ? "0.1" : "1"}
          value={formState.baselineValue}
          onChange={handleInputChange}
          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-700 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700"
        />
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
          {formState.testType === 'conversion' 
            ? 'Current conversion rate (e.g., 10 for 10%)' 
            : 'Current average value of your metric'}
        </p>
      </div>
      
      {/* Standard Deviation (only for metric tests) */}
      {showStdDev && (
        <div>
          <label htmlFor="standardDeviation" className="block text-sm font-medium mb-2">
            Standard Deviation
          </label>
          <input
            type="number"
            id="standardDeviation"
            name="standardDeviation"
            min="0.01"
            value={formState.standardDeviation}
            onChange={handleInputChange}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-700 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700"
          />
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
            Variability of your metric (if unknown, use 50% of the mean as an estimate)
          </p>
        </div>
      )}
      
      {/* Minimal Detectable Effect */}
      <div>
        <label htmlFor="mde" className="block text-sm font-medium mb-2">
          Minimal Detectable Effect (%)
        </label>
        <div className="flex items-center">
          <input
            type="range"
            id="mde"
            name="mde"
            min="1"
            max="50"
            step="1"
            value={formState.mde}
            onChange={handleInputChange}
            className="w-full h-2 bg-gray-200 dark:bg-gray-700 rounded-lg appearance-none cursor-pointer"
          />
          <span className="ml-2 w-10 text-center">{formState.mde}%</span>
        </div>
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
          The smallest relative improvement you want to detect 
          {formState.testType === 'conversion' 
            ? ` (${formState.mde}% equals a ${(formState.baselineValue * formState.mde / 100).toFixed(2)} ppt increase of the baseline)`
            : ` (${formState.mde}% equals a ${(formState.baselineValue * formState.mde / 100).toFixed(2)} unit increase of the baseline)`
          }
        </p>
      </div>
      
      {/* Daily Samples */}
      <div>
        <label htmlFor="dailySamples" className="block text-sm font-medium mb-2">
          Daily Samples/Interactions
        </label>
        <input
          type="number"
          id="dailySamples"
          name="dailySamples"
          min="1"
          value={formState.dailySamples}
          onChange={handleInputChange}
          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-700 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700"
        />
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
          The avg. number of target interactions per day determines the estimated time needed
        </p>
      </div>
    </div>
  );
};

export default DataInputForm;
